import { render, staticRenderFns } from "./QuarantineCampaignAlert.vue?vue&type=template&id=47a913c0"
import script from "./QuarantineCampaignAlert.vue?vue&type=script&lang=js"
export * from "./QuarantineCampaignAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports